import { atom } from "jotai";

export const selectedSkillIdAtom = atom<number | undefined>(undefined);

export const collapsedConditionalStepGroupIdsAtom = atom(new Set<string>());

export const collapsedSectionStepIdsAtom = atom(new Set<string>());
